import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  Renderer2,
  ViewChildren,
  QueryList,
  OnDestroy
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment.prod';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { HeaderService } from 'src/_lib/service/header.service';
import { ThemePermissionMatrixService } from 'src/_lib/service/theme-permission-matrix.service';
import { ProductService } from 'src/_lib/service/product.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { LoginService } from 'src/_lib/service/login.service';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { HeadersDataInterface, RowData } from 'src/_lib/interfaces/header.interface';
import { ProductVariationSearchInterface } from 'src/_lib/interfaces/product.interface';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss', './header-nav-ch2.component.scss', './header-nav-ch3.component.scss', './header-nav-ch11.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgFor,
    NgIf,
    NgClass,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    FormsModule,
    RouterLinkActive
  ]
})
export class HeaderNavComponent implements OnInit, AfterViewInit, OnDestroy {
  firstObj: number = this.appConstants.firstObj;
  storeImagePath: string = environment.storeImagePath;
  cdnImagePath: string = environment.cdnImagePath;
  product_variation_key = null;
  product_key: number = null;
  username: string = '';
  vehicleName: string = '';
  modifiedStr: string = '';
  headerdata: HeadersDataInterface = {
    websiteHeader: [],
    firstRow: [],
    secondRow: [],
    thirdRow: [],
  };
  chTheme1 = environment.chTheme1;
  chTheme2 = environment.chTheme2;
  chTheme4 = environment.chTheme4;
  chTheme3 = environment.chTheme3;
  chTheme5 = environment.chTheme5;
  chTheme6 = environment.chTheme6;
  chTheme7 = environment.chTheme7;
  chTheme9 = environment.chTheme9;
  chTheme8 = environment.chTheme8;
  chTheme10 = environment.chTheme10;
  chTheme11 = environment.chTheme11;
  isNavbarCollapsed: boolean = true;
  subCategoriesData: any = [];
  category_key: number;
  cartItems: number = 0;
  displayDropDownMenuSearch: boolean = false;
  headerSearchName: boolean = false;
  headerSearchHash: boolean = false;
  navBarElementsArray: any[] = [];
  applyCustomClass: boolean = false;
  applyCustomVehicleClass: boolean = false;
  scrollStrategy: ScrollStrategy;
  openMobileViewSubCat: Array<boolean> = [];
  searchValueByPartName: string = '';
  searchValueByPartHash: string = '';
  private searchSubject = new Subject<string>();
  private partHashSubject = new Subject<string>();
  searchResultArrayByPartName: any[] = [];
  searchResultArrayByPartHash: any[] = [];
  isProductPage: boolean = false;
  showLogOutDesktop: boolean;
  widnowResizeEvent: any;
  menuData: any = {};
  menuData1: any = {};
  menuData2: any = {};
  activeDropdownIndex: number = -1;
  private clickListener: any;

  @Input() dataFromController1: string;
  @ViewChild('DropdownMenuSearch') DropdownSearchMenuElementRef: ElementRef;
  @ViewChild('SearchIcon') SearchIcon: ElementRef;
  @ViewChild('ListsearchByPartName') ListElementSearchByPartNameRef: ElementRef;
  @ViewChild('ListsearchByPartHash') ListElementSearchByPartHashRef: ElementRef;
  @ViewChild('DivSearchByPartName') DivElementSearchByPartNameRef: ElementRef;
  @ViewChild('DivSearchByPartHash') DivElementSearchByPartHashRef: ElementRef;
  @ViewChildren('navBarElements') navBarElements: QueryList<ElementRef>;
  @ViewChildren('dropdownItemsNavBar')
  dropdownItemsNavBar: QueryList<ElementRef>;

  constructor(
    private appConstants: AppConstants,
    private headerHttp: HeaderService,
    private router: Router,
    private renderer: Renderer2,
    private comm: CommunicationService,
    public dialog: MatDialog,
    private readonly sso: ScrollStrategyOptions,
    private themepermission: ThemePermissionMatrixService,
    private productService: ProductService,
    private commonService: CommanpageService,
    private route: ActivatedRoute,
    public loginService: LoginService,
    private browser: BrowserService,
    private dynamicThemeClassService: DynamicThemeClassService
  ) {
    this.scrollStrategy = this.sso.noop();
    this.vehiclenameSubject();
    this.searchChangeByPartName();
    this.searchChangeByPartHash();
    this.browser.runInBrowser(() => {
      this.widnowResizeEvent = this.browser.window?.addEventListener('resize', () => {
        this.showLogOutDesktop = (this.browser.window?.innerWidth ?? 0) > 575;
      });
    });
  }

  themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }

  ngOnInit(): void {
    this.browser.runInBrowser(() => {
      this.showLogOutDesktop = (this.browser.window?.innerWidth ?? 0) > 575;
    });
    this.product_key =
      +(this.browser.localStorage?.getItem('selectedproductkey') || 0) || null;
    this.product_variation_key =
      +(this.browser.localStorage?.getItem('selectedproductvariationkey') || 0) || null;
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdata = data[this.firstObj].data;
    });
    this.themepermission.homepageSettings().subscribe((data) => {
      this.menuData = data[this.firstObj].data?.menus || {};
    });
    this.vehicleName = this.browser.localStorage?.getItem('vehiclename') || '';
    this.getorderitems();
    this.username = this.browser.localStorage?.getItem('Username');
    this.route.params.subscribe({
      next: (params: Params) => {
        let id: string = params['id'];
        if (id) {
          const pattern: boolean = /^[0-9]*$/.test(id.slice(1, id?.length));
          if (id.startsWith('p') && id?.length > 0 && pattern) {
            this.isProductPage = true;
          } else {
            this.isProductPage = false;
          }
        }
      },
    });
  }

  goToLogin() {
    const currentUrl = this.router.url;
    this.browser.localStorage?.setItem('redirectAfterLogin', currentUrl);
    this.router.navigate(['/customer-login']);
  }

  onClickMobileUser() {
    const isLoggedIn = this.loginService.isUserLoggedIn();
    if (isLoggedIn) {
      this.router.navigate(['/my-account']);
    } else {
      this.router.navigate(['/customer-login']);
    }
  }

  vehiclenameSubject() {
    this.comm.vehiclenameSubject.subscribe({
      next: (name) => {
        this.vehicleName = name;
      },
      error: (error: Error) => {
        this.vehicleName = '';
        console.error(
          'Custom Error: Unexpected Error while subscribing to vehicle Name',
          error,
        );
      },
    });
  }

  ngAfterViewInit(): void {
    if (!this.browser.isBrowser) return;

    const doc = this.browser.doc;
    if (!doc) return;

    this.clickListener = (event: Event) => {
      if (
        !this.DropdownSearchMenuElementRef?.nativeElement?.contains(
          event.target,
        ) &&
        !this.SearchIcon?.nativeElement?.contains(event.target)
      ) {
        this.displayDropDownMenuSearch = false;
      } else if (
        this.DropdownSearchMenuElementRef?.nativeElement?.contains(
          event.target,
        ) &&
        (this.ListElementSearchByPartNameRef?.nativeElement?.contains(
          event.target,
        ) ||
          (this,
          this.ListElementSearchByPartHashRef?.nativeElement?.contains(
            event.target,
          )))
      ) {
        this.displayDropDownMenuSearch = false;
      }
      if (
        this.ListElementSearchByPartNameRef?.nativeElement?.contains(
          event.target,
        )
      ) {
        this.headerSearchName = true;
      } else if (
        !this.DivElementSearchByPartNameRef?.nativeElement?.contains(
          event.target,
        )
      ) {
        this.headerSearchName = false;
        this.searchValueByPartName = '';
      }
      if (
        this.ListElementSearchByPartHashRef?.nativeElement?.contains(
          event.target,
        )
      ) {
        this.headerSearchHash = true;
      } else if (
        !this.DivElementSearchByPartHashRef?.nativeElement?.contains(
          event.target,
        )
      ) {
        this.headerSearchHash = false;
        this.searchValueByPartHash = '';
      }
    };
    this.navBarElements.changes.subscribe((elements) => {
      this.navBarElementsArray = [];
      elements.toArray().forEach((element) => {
        this.navBarElementsArray.push(element);
      });
    });
  }

  onClickSearchIcon() {
    this.displayDropDownMenuSearch = !this.displayDropDownMenuSearch;
  }

  boolSearchDivName() {
    this.headerSearchName = true;
  }

  boolSearchDivHash() {
    this.headerSearchHash = true;
  }

  displaySearchDivbyPartName(): string {
    return this.headerSearchName ? 'block' : 'none';
  }

  displaySearchDivbyPartHash(): string {
    return this.headerSearchHash ? 'block' : 'none';
  }

  getSubCategories() {
    this.headerHttp.headerNavCategoriesSubCategories().subscribe({
      next: (response) => {
        if (response[this.firstObj]?.success == true) {
          this.subCategoriesData = response[this.firstObj]?.data;
        } else {
          this.subCategoriesData = [];
        }
      },
      error: (error: Error) => {
        console.error(
          'Custom Error: Unexpected Error while fetching Categories-Subcategories dropdown data',
          error,
        );
      },
    });
  }

  onClickmobileCategories(header: RowData) {
    let elementref =
      this.dropdownItemsNavBar.find(
        (element) => element.nativeElement.id == header.menu_name,
      ) || null;
    if (!!elementref) {
      const hasClass =
        elementref.nativeElement.classList.contains('displaySubMenus');
      if (hasClass) {
        this.renderer.removeClass(elementref.nativeElement, 'displaySubMenus');
        this.renderer.addClass(elementref.nativeElement, 'nodisplaySubMenus');
        this.categoriesRedirection(header, 'mobile');
      } else {
        this.renderer.removeClass(
          elementref.nativeElement,
          'nodisplaySubMenus',
        );
        this.renderer.addClass(elementref.nativeElement, 'displaySubMenus');
      }
    } else {
      this.categoriesRedirection(header, 'mobile');
    }
  }

  categoriesRedirection(
    header: RowData,
    view: 'mobile' | 'desktop' = 'desktop',
  ): void {
    if (view == 'mobile') {
      this.toggleNavbar();
    }
    if (header.menu_link == '#vehicleSearch') {
      this.openVechicleSearchPopup();
      return;
    }
    const categoryIdMatch = header.menu_link.match(/\/c(\d+)/);
    this.category_key = parseInt(categoryIdMatch[1], 10);
    if (categoryIdMatch && categoryIdMatch[1]) {
      if (this.category_key) {
        this.browser.localStorage?.setItem(
          'selectedcategorykey',
          String(this.category_key),
        );
        if (this.router.url == '/category-details') {
          this.comm.categoryKeyChange.next(null);
        }
      }
      this.router.navigate([header.menu_link]);
    }
  }

  openVechicleSearchPopup(): void {
    this.dialog.open(SearchByVehicleComponent, {});
  }

  openVechiclePopup(): void {
    this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog',
    });
  }

  onMouseLeaveDropdownListElement(
    event: MouseEvent,
    element: HTMLUListElement,
    name: string,
  ) {
    for (let i = 0; i < this.navBarElementsArray?.length; i++) {
      this.renderer.removeClass(
        this.navBarElementsArray[i].nativeElement,
        'custom-navBar-Hover',
      );
    }
    if (name != 'Search By Vehicle ') {
      this.renderer.removeClass(event.target, 'open');
      this.renderer.setStyle(element, 'display', 'none');
    }
  }

  onMouseHoverDropdownListElement(
    event: MouseEvent,
    element: HTMLUListElement,
    name: string,
  ) {
    for (let i = 0; i < this.navBarElementsArray?.length; i++) {
      if (this.navBarElementsArray[i].nativeElement == event.target) {
        this.renderer.addClass(event.target, 'custom-navBar-Hover');
      }
    }
    if (name != 'Search By Vehicle ') {
      this.renderer.addClass(event.target, 'open');
      this.renderer.setStyle(element, 'display', 'block');
    }
  }

  subCategoryRedirection(
    event: Event,
    element: HTMLUListElement,
    category_key: number,
    view: 'mobile' | 'desktop' = 'desktop',
  ) {
    if (view == 'mobile') {
      this.toggleNavbar();
    }
    this.browser.localStorage?.setItem('selectedcategorykey', String(category_key));
    this.comm.categoryKeyChange.next(null);
    this.renderer.removeClass(event.target, 'open');
    this.renderer.setStyle(element, 'display', 'none');
    for (let i = 0; i < this.navBarElementsArray?.length; i++) {
      this.renderer.removeClass(
        this.navBarElementsArray[i].nativeElement,
        'custom-navBar-Hover',
      );
    }
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  //HTML AND CSS changed programatically
  displayName(menu_name: string) {
    if (menu_name == 'Search By Vehicle ') {
      if (!!this.vehicleName) {
        return this.vehicleName;
      } else {
        return menu_name;
      }
    } else {
      return menu_name;
    }
  }

  vehicleImage() {
    return `${this.displayName('Search By Vehicle ')} <img src='/assets/images/mcLeod_header_car_ico.png' loading="eager" alt='car-logo' width='34' height='12'>`;
  }

  applySubCategoryCustomClass(menu_name: string) {
    if (menu_name !== 'Search By Vehicle ') {
      this.applyCustomClass = true;
    }
  }

  removeSubCategoryCustomClass(menu_name: string) {
    if (menu_name != 'Search By Vehicle ') {
      this.applyCustomClass = false;
    }
  }

  applyCustomVehicleClassMethod(menu_name: string) {
    if (menu_name == 'Search By Vehicle ') {
      this.applyCustomVehicleClass = true;
    }
  }

  removeCustomVehicleClassMethod(menu_name: string) {
    if (menu_name == 'Search By Vehicle ') {
      this.applyCustomVehicleClass = false;
    }
  }

  getorderitems(): void {
    this.cartItems = +(this.browser.localStorage?.getItem('ItemCount') || 0);
    this.comm.itemCount.subscribe(() => {
      this.cartItems = +(this.browser.localStorage?.getItem('ItemCount') || 0);
    });
  }

  onInputvalueChangeByPartName() {
    this.searchSubject.next(this.searchValueByPartName);
  }

  onInputvalueChangeByPartHash() {
    this.partHashSubject.next(this.searchValueByPartHash);
  }

  searchChangeByPartName() {
    this.searchSubject
      .pipe(
        debounceTime(300), // Adjust the debounce time as needed
        switchMap((value) =>
          this.productService.productByPartNameSearchResults(value),
        ),
      )
      .subscribe({
        next: (resultArray: ProductVariationSearchInterface[]) => {
          this.searchResultArrayByPartName = [];
          if (resultArray?.length > 0) {
            this.searchResultArrayByPartName = resultArray;
          }
        },
        error: (error: Error) => {
          console.error(
            'Custom Error: Unexpected Error while fetching data from products SearchByPartName',
            error,
          );
        },
      });
  }

  searchChangeByPartHash() {
    // Handle search for part hash
    this.partHashSubject
      .pipe(
        debounceTime(300), // Adjust the debounce time as needed
        switchMap((value) =>
          this.productService.productByPartHashSearchResults(value),
        ),
      )
      .subscribe({
        next: (resultArray: ProductVariationSearchInterface[]) => {
          this.searchResultArrayByPartHash = [];
          if (resultArray?.length > 0) {
            this.searchResultArrayByPartHash = resultArray;
          }
        },
        error: (error: Error) => {
          console.error(
            'Custom Error: Unexpected Error while fetching data from product-variations searchByPartHash',
            error,
          );
        },
      });
  }

  onClickSearchByPartNameResult(productKey: number, productName: string): void {
    this.browser.localStorage?.removeItem('selectedproductvariationkey');
    this.product_variation_key = null;
    if (this.isProductPage && this.product_key != productKey) {
      this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
      this.product_key = productKey;
      this.comm.searchByPartNameProductKeyChange.next(null);
    } else if (this.isProductPage && this.product_key == productKey) {
    } else if (!this.isProductPage && this.product_key != productKey) {
      this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
      this.product_key = productKey;
    }
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    this.commonService.productRedirection(productName, productKey)
    this.comm.serchByPartHashKeyChange.next(null);
    this.headerSearchName = false;
    this.searchValueByPartName = '';
  }

  onClickSearchByPartHashResult(
    productKey: number,
    productVariationKey: number,
    productName: string,
    sku: string,
  ): void {
    const skuName = this.commonService.setUrlNameField(sku);
    if (sku.includes(' ')) {
      this.browser.localStorage?.setItem('replaceDashSku', String(true));
    }
    if (!this.isProductPage) {
      this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
      if (this.product_key != productKey) {
        this.product_key = productKey;
        this.browser.localStorage?.setItem(
          'selectedproductvariationkey',
          String(productVariationKey),
        );
        this.product_variation_key = productVariationKey;
        const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
        const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
        updatedProducts.unshift(productKey);
        this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
        this.commonService.productRedirection(productName, productKey)
      }
      else if (this.product_key == productKey && this.product_variation_key != productVariationKey) {
        this.browser.localStorage?.setItem('selectedproductvariationkey', String(productVariationKey));
        this.product_variation_key = productVariationKey;
        const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
        const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
        updatedProducts.unshift(productKey);
        this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
        this.commonService.productRedirection(productName, productKey)
      }
      else if (this.product_key == productKey && this.product_variation_key == productVariationKey) {
        const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
        const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
        updatedProducts.unshift(productKey);
        this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
        this.commonService.productRedirection(productName, productKey)
      }
    }
    else if (this.isProductPage) {
      if (this.product_key != productKey) {
        this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
        this.product_key = productKey;
        this.browser.localStorage?.setItem(
          'selectedproductvariationkey',
          String(productVariationKey),
        );
        this.product_variation_key = productVariationKey;
        this.comm.searchByPartNameProductKeyChange.next(null);
      } else if (
        this.product_key == productKey &&
        this.product_variation_key != productVariationKey
      ) {
        this.browser.localStorage?.setItem(
          'selectedproductvariationkey',
          String(productVariationKey),
        );
        this.product_variation_key = productVariationKey;
        this.comm.serchByPartHashKeyChange.next(null);
      } else if (
        this.product_key == productKey &&
        this.product_variation_key == productVariationKey
      ) {
        return;
      }
    }
    this.headerSearchHash = false;
    this.searchValueByPartHash = '';
  }

  toggleDropdown(tabIndex: number) {
    if (this.activeDropdownIndex !== tabIndex) {
      this.activeDropdownIndex = tabIndex;
    } else {
      this.activeDropdownIndex = -1;
    }
  }

  get filteredFirstRow() {
    const filteredData =
      this.headerdata?.firstRow?.filter((item) => item.menu_link !== '') || [];
    this.browser.localStorage?.setItem(
      'filteredFirstRow',
      JSON.stringify(filteredData),
    );
    return filteredData;
  }

  ngOnDestroy(): void {
    if (!this.browser.isBrowser) return;
    if (!this.browser.doc) return;
    this.browser.doc.removeEventListener('click', this.clickListener);
    this.browser.window?.removeEventListener('resize', this.widnowResizeEvent);
  }
}